/** @format */

export enum IdentityKind {
    CUSTOMER = 'customer',
    OAUTH = 'oauth',
    ANONYMOUS = 'anonymous',
}
